import styled, { css } from 'styled-components/macro'

import { fluidSystem, mediaM } from 'styled'

export const Root = styled.div`
  ${fluidSystem};
  position: relative;
  width: 100%;
  height: 100%;

  > .Inner {
    display: flex;
    flex-direction: column;

    ${mediaM`
      justify-content: center;
    `};

    @media screen and (max-height: 800px) {
      justify-content: flex-start;
    }
  }
`

export const OptionList = styled.div`
  ${fluidSystem};
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`

export const PctBox = styled.div`
  ${fluidSystem};
  flex: 0 999 100%;
`

export const OptionRow = styled.div`
  ${fluidSystem};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 32px 0;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(221, 221, 221, 0.5);
  }

  ${({ leaving, entering, nth, navDirection }) => css`
    opacity: ${leaving || entering ? 0 : 1};
    transform: translate(${(leaving ? -50 : entering ? 50 : 0) * navDirection}%, 0);
    transition: all 0.3s ${navDirection * nth * 0.05 + 0.25}s;
  `};

  ${mediaM`
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `};
`

export const GraphicsBox = styled.div`
  ${fluidSystem};
  flex: 0 0 auto;
`

export const QuestionWrapper = styled.div`
  ${fluidSystem};
  margin-bottom: 40px;

  ${({ leaving, entering, navDirection }) => css`
    opacity: ${leaving || entering ? 0 : 1};
    transform: translate(${(leaving ? -25 : entering ? 25 : 0) * navDirection}%, 0);
    transition: all 0.3s 0.3s;
  `};

  ${mediaM`
    display: none;
  `};
`
